const toneClasses = {
  success: 'tw-border-emerald-600 tw-bg-emerald-50 tw-text-emerald-700',
  warning: 'tw-border-amber-600 tw-bg-amber-50 tw-text-amber-700',
  danger: 'tw-border-rose-600 tw-bg-rose-50 tw-text-rose-700',
  info: 'tw-border-sky-600 tw-bg-sky-50 tw-text-sky-700',
  neutral: 'tw-border-slate-500 tw-bg-slate-50 tw-text-slate-600',
};

export default function StatusBadge({ children, tone = 'neutral', className = '' }) {
  return (
    <span className={`tw-inline-flex tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded-full tw-border tw-border-solid tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 ${toneClasses[tone] || toneClasses.neutral} ${className}`}>
      {children}
    </span>
  );
}
